import React from 'react';

import { Color, ComponentSize } from '../../../typings/design-tokens';
import { IComponent } from '../../../typings/generic-component';
import { makeClassNames } from '../../../utils/styles';

import './icon.scss';

export const iconSizeList: ComponentSize[] = [
  'xxxsmall',
  'xxsmall',
  'xsmall',
  'small',
  'medium',
  'large',
  'xlarge',
  'xxlarge',
];

export type VerticalAlign = 'top' | 'middle' | 'bottom';
export const verticalAlignList: VerticalAlign[] = ['top', 'middle', 'bottom'];

export interface IIconCustomSize {
  width: string;
  height: string;
}

export interface IIcon extends IComponent {
  svg?: Function;
  reverse?: Boolean;
  verticalAlign?: VerticalAlign;
  customSize?: IIconCustomSize | null;
}

const sizes: { [key: string]: any } = Object.freeze({
  xxxsmall: 8,
  xxsmall: 14,
  xsmall: 20,
  small: 30,
  medium: 60,
  large: 80,
  xlarge: 100,
  xxlarge: 150,
});

const classNames = (
  color: Color,
  size: ComponentSize,
  verticalAlign: VerticalAlign | undefined,
  reverse: boolean | Boolean,
  customSize = false
) =>
  makeClassNames({
    icon: [
      `icon icon--c-${color}`,
      !customSize && `icon--${size}`,
      customSize && 'icon--custom-size',
      verticalAlign && `icon--align-${verticalAlign}`,
      reverse && 'icon--reverse',
    ],
  });

const Icon = ({
  color = 'inherit',
  size = 'xsmall',
  svg = () => {},
  reverse = false,
  verticalAlign,
  customSize = null,
}: IIcon) => {
  const cn = classNames(color, size, verticalAlign, reverse, Boolean(customSize));

  return (
    <i className={cn.icon}>
      {svg({
        width: customSize?.width ?? sizes[size],
        height: customSize?.height ?? sizes[size],
      })}
    </i>
  );
};

export default Icon;
